import { render, staticRenderFns } from "./ArticleItemView.vue?vue&type=template&id=9920c0ac"
import script from "./ArticleItemView.vue?vue&type=script&lang=js"
export * from "./ArticleItemView.vue?vue&type=script&lang=js"
import style0 from "./ArticleItemView.vue?vue&type=style&index=0&id=9920c0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports